import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Smartphone } from "lucide-react";
import { Logo } from "./brand/Logo";
import { useAuth } from "../context/AuthContext";
import { useAuthModal } from "../context/AuthModalContext";
import { isPhone, isStandalone } from "../hooks/useInstallPrompt";
import { trackAppTap } from "../lib/appStats";

export const SiteNav = ({ banner = null }) => {
  const { user } = useAuth();
  const { openLogin, openSignup } = useAuthModal();
  const { pathname } = useLocation();
  return (
    <header className="fixed top-0 inset-x-0 z-40 border-b border-slate-200/80 bg-white/75 backdrop-blur-xl">
      {banner}
      <div className="max-w-7xl mx-auto h-16 px-4 sm:px-6 lg:px-8 flex items-center justify-between">
        <Logo />
        <nav className="hidden md:flex items-center gap-8 text-sm text-slate-500">
          <a href="/#how" className="hover:text-slate-900 transition-colors" data-testid="nav-how-link">How it works</a>
          <a href="/#features" className="hover:text-slate-900 transition-colors" data-testid="nav-features-link">Features</a>
          <a href="/#pricing" className="hover:text-slate-900 transition-colors" data-testid="nav-pricing-link">Pricing</a>
          <Link to="/about" className="hover:text-slate-900 transition-colors" data-testid="nav-about-link">About</Link>
        </nav>
        <div className="flex items-center gap-2">
          {!isStandalone() && pathname !== "/get-app" && isPhone() && (
            <Link to="/get-app" onClick={() => trackAppTap("nav")} data-testid="nav-get-app-btn" aria-label="Get the app"
              className="group h-9 w-9 sm:w-auto sm:px-3.5 inline-flex items-center justify-center gap-1.5 rounded-lg border border-sky-200 bg-sky-50 text-sky-700 text-sm font-semibold hover:bg-sky-100 transition-colors">
              <Smartphone size={16} className="transition-transform duration-200 group-hover:-rotate-12" />
              <span className="hidden sm:inline">Get the app</span>
            </Link>
          )}
          {user ? (
            <Link to="/home" data-testid="nav-dashboard-btn" className="h-9 px-4 inline-flex items-center rounded-lg bg-slate-900 text-white text-sm font-semibold hover:bg-slate-700 transition-colors">
              Open dashboard
            </Link>
          ) : (
            <>
              <button onClick={openLogin} data-testid="nav-login-btn" className="h-9 px-3 text-sm text-slate-600 hover:text-slate-900 transition-colors">
                Log in
              </button>
              <button onClick={openSignup} data-testid="nav-signup-btn" className="h-9 px-4 rounded-lg bg-slate-900 text-white text-sm font-semibold hover:bg-slate-700 transition-colors">
                Get started
              </button>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export default SiteNav;
